/**
 * Grid Overlay Component - Visual grid overlay for the canvas
 * Shows a repeating grid pattern to help with alignment
 */

import React, { useMemo } from 'react';
import { CANVAS_THEME } from './canvas-theme';

export interface GridOverlayProps {
  gridSize?: number;
}

/**
 * GridOverlay Component
 * Displays a visual grid using repeating linear gradients
 * Lightweight and performant
 */
export function GridOverlay({ gridSize = CANVAS_THEME.gridSize }: GridOverlayProps) {
  const backgroundImage = useMemo(() => {
    const gridSizeStr = `${gridSize}px`;
    return `
      repeating-linear-gradient(
        0deg,
        ${CANVAS_THEME.gridColor} 0px,
        ${CANVAS_THEME.gridColor} 1px,
        transparent 1px,
        transparent ${gridSizeStr}
      ),
      repeating-linear-gradient(
        90deg,
        ${CANVAS_THEME.gridColor} 0px,
        ${CANVAS_THEME.gridColor} 1px,
        transparent 1px,
        transparent ${gridSizeStr}
      )
    `;
  }, [gridSize]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundImage,
        pointerEvents: 'none',
        zIndex: CANVAS_THEME.zIndex.grid,
      }}
    />
  );
}
